<template>
	<div>
		<indexHeader ref="indexHeader"></indexHeader>
		<div id="app">
		  <div class="main">
		    <checkModel></checkModel>
		  </div>
		</div>
		<indexFooter></indexFooter>
	</div>
  
</template>
<script type="text/ecmascript-6">
  import 'babel-polyfill'//IE9，模拟ES6环境
  import '@/common/less/index.less'
  import {cookie} from '@/common/js/cookies.js'
  import  checkModel from '@/components/exam/check'
	import indexHeader from "@/components/index/index_header";
	import indexFooter from "@/components/index/index_footer";

  export default {
    name: 'app',
    data(){
      return {
      }
    },
    computed: {

    },
    created: function () {

    },
    mounted(){
      // console.log(this.$router);
      // this.$router.push('/course');
    },
    methods: {
    },
    components: {
			indexHeader,
			indexFooter,
      checkModel
    },
    watch: {

    }
  }
</script>

<style scoped lang="less" type="text/less">
  #app{
    .header{
      background: #fff;
    }
  }
  .main{
    // width: 1210px;
	width: 1180px;
    margin: 0 auto;
    padding-top: 22px;
    min-height: 800px;

  }
  .footer{
    height: 250px;
    width: 100%;
    background: #06172a;
    .con{
      // width: 1210px;
	  width: 1180px;
      margin: 0 auto;
    }
  }

</style>



// WEBPACK FOOTER //
// src/module/exam/exam.vue